// extracted by mini-css-extract-plugin
export var bodySections = "_ab-8";
export var gray = "_ab-7";
export var green = "_ab-4";
export var iconContainer = "_ab-9";
export var iconWidgetContainer = "_ab-1";
export var phoneIcon = "_ab-2";
export var red = "_ab-5";
export var statusDot = "_ab-3";
export var widgetContainer = "_ab-0";
export var yellow = "_ab-6";